import type { ProofreadingRuleEntry } from "@/lib/api/proofreading";

/**
 * フリープランで選択可能な校正カテゴリ（= プレミアムではないカテゴリ）。
 * ProofreadingItemSelectDialog のプレミアム判定と初回デフォルト選択で共通利用する。
 */
export const FREE_PROOFREADING_CATEGORY_IDS = [
  "typo",
  "brackets_and_indent",
  "punctuation_symbols",
] as const;

export function isFreeProofreadingCategory(categoryId: string): boolean {
  return (FREE_PROOFREADING_CATEGORY_IDS as readonly string[]).includes(categoryId);
}

/** 初回アクセス時（selectedRuleIds 未設定）のデフォルト選択ルール ID 一覧。 */
export function getDefaultSelectedRuleIds(rules: ProofreadingRuleEntry[]): string[] {
  return rules.filter((rule) => isFreeProofreadingCategory(rule.category)).map((rule) => rule.rule);
}
